// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"default-src_app_Infraestructure_services_get-token_service_ts-src_app_Infraestructure_service-fd9102":"2c26bc81c8856b9c","src_app_Infraestructure_pages_nps-puntos_nps-puntos_module_ts":"3b20ebc490188d13","src_app_Infraestructure_pages_nps-coins_nps-coins_module_ts":"e8678423cd0dd27d"}[chunkId] + ".js";
};